import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import modalCancelActions from 'actions/modalCancelActions';
import logActions from 'actions/logActions';
import stepsActions from 'actions/stepsActions';
import { SessionTimeoutModal } from 'components/sessionTimeOut/SessionTimeoutModal/SessionTimeoutModal';
import { SessionExpiredModal } from 'components/sessionTimeOut/SessionExpiredModal/SessionExpiredModal';
import { SessionOverWrittenModal } from 'components/sessionTimeOut/SessionOverWrittenModal/SessionOverWrittenModal';
import React from 'react';
import '../../styles/blocks/_blowup-modal.scss';
import '../../styles/blocks/_session-timeout-modal.scss';
import { useTimeLeftCheckFromExpirationRequest } from 'components/sessionTimeOut/hooks/useTimeLeftCheckFromExpirationRequest';
import { useTimeOutModalCheck } from 'components/sessionTimeOut/hooks/useTimeOutModalCheck';
import { renewSession } from 'components/sessionTimeOut/utils/renewSession';
import {
    doTagExitSessionEvent,
    doTagRenewSessionEvent,
    doTagSignOutSessionEvent,
} from 'components/sessionTimeOut/tagging';
import { isMobile } from 'utilities/browser';
import { LOGIN_DESKTOP, LOGIN_MOBILE, PUBLICA_URL } from 'constants';
import { logout } from 'components/sessionTimeOut/utils/logout';
import { removeSessionCookies } from 'components/sessionTimeOut/utils/removeSessionCookies';
import { useExpirationModalCheck } from 'components/sessionTimeOut/hooks/useExpirationModalCheck';
import { useOverWrittenModalCheck } from 'components/sessionTimeOut/hooks/useOverWrittenModalCheck';

const SessionTimeOut = ({ userProfile, session, products, modalCancelActions, logActions, stepsActions }) => {
    const productsDescription = products.get('productsDescription');

    const { stopTimeLeftCheck } = useTimeLeftCheckFromExpirationRequest({
        session,
        accessToken: userProfile.accessToken,
        checkSession: logActions.checkSession,
    });

    const { showTimeoutModal, timeOutBlowupClass, closeTimeOutModal } = useTimeOutModalCheck({
        session,
        modalCancelActions,
    });
    const { showExpiredModal, expiredBlowupClass, openExpirationModal, closeExpirationModal } = useExpirationModalCheck(
        {
            session,
            onExpirationModalOpen: () => {
                stopTimeLeftCheck();
                closeTimeOutModal();
            },
            modalCancelActions,
        }
    );
    const { showOverWrittenModal, overwrittenBlowupClass } = useOverWrittenModalCheck({
        session,
        onOverWrittenModalOpen: () => {
            stopTimeLeftCheck();
            closeTimeOutModal();
        },
        modalCancelActions,
        stepsActions,
    });

    const handleRenewSessionTime = () => {
        closeTimeOutModal();

        renewSession({ refreshToken: userProfile.refreshToken, renewAction: logActions.renewSession });

        doTagRenewSessionEvent(userProfile);
    };

    const handleSignOut = () => {
        closeTimeOutModal();

        logout({ accessToken: userProfile.accessToken, logoutAction: logActions.logout });

        removeSessionCookies();

        doTagSignOutSessionEvent(userProfile);

        window.location.href = PUBLICA_URL;
    };

    const handleExit = (loginOpen = false) => {
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        logout({ accessToken: userProfile.accessToken, logoutAction: logActions.logout });

        removeSessionCookies();

        if (showExpiredModal) {
            closeExpirationModal();
        }
        doTagExitSessionEvent(userProfile);

        window.location.href = loginOpen ? PUBLICA_URL + mobileLoginToggleString : PUBLICA_URL;
    };

    return (
        <div>
            <SessionTimeoutModal
                showModal={showTimeoutModal}
                modalClass={`timeout-modal ${timeOutBlowupClass}`}
                userProfile={userProfile}
                sessionStatus={session.get('sessionStatus')}
                onTimeExpiration={openExpirationModal}
                onHide={closeTimeOutModal}
                onClickSignOut={handleSignOut}
                onClickContinue={handleRenewSessionTime}
            />
            <SessionExpiredModal
                showModal={showExpiredModal}
                modalClass={`timeout-modal expired-modal ${expiredBlowupClass}`}
                userProfile={userProfile}
                productsDescription={productsDescription}
                onExit={() => handleExit()}
                onHide={closeExpirationModal}
                onClickLoginAgain={() => handleExit(true)}
            />
            <SessionOverWrittenModal
                showModal={showOverWrittenModal}
                modalClass={`timeout-modal overwritten-modal ${overwrittenBlowupClass}`}
                userProfile={userProfile}
                productsDescription={productsDescription}
                onClickUnderstood={() => handleExit(true)}
            />
        </div>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        session: state.session,
        products: state.products,
    }),
    dispatch => ({
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        logActions: bindActionCreators(logActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
    })
)(SessionTimeOut);
